<form [formGroup]="configurationFormManualImport">
  <div class="form-row row">
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-templateVersion" class="control-label required">{{ 'i18n.domain.import-configuration.edit.manual-import.templateVersion' | translate }}</label>
      <input id="ic-templateVersion" type="text" class="form-control" formControlName="templateVersion" />
      <app-error-messages [control]="configurationFormManualImport.controls.templateVersion"></app-error-messages>
    </div>
  </div>
</form>
